import { type TranslationTree } from '@/i18n/types';

export const messages = {
  brandTag: 'Partners',
} satisfies TranslationTree;
